import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { appointmentApiService } from "../services/appointmentApiService";
import { fromAppointmentFormsReviewDto } from "../types/appointmentFormTypes";

export const appointmentFormKeys = {
  scope: (userId?: string, businessId?: string) => ["appointment-forms", userId, businessId] as const,
};

export function useAppointmentFormsReview(serviceIds: string[], appointmentId?: string, revision?: number, enabled = true) {
  const { user } = useAuth();
  const { businessId } = useCurrentBusiness();
  const ids = [...new Set(serviceIds)].sort();
  return useQuery({
    queryKey: [...appointmentFormKeys.scope(user?.id, businessId), appointmentId, revision, ids],
    queryFn: async ({ signal }) => {
      if (!businessId || !user) throw new Error("Choose a business and sign in to review forms.");
      const dto = await appointmentApiService.reviewForms(businessId, ids, appointmentId, revision, signal);
      signal.throwIfAborted();
      return fromAppointmentFormsReviewDto(dto);
    },
    enabled: enabled && !!user && !!businessId,
    staleTime: 0,
    refetchOnWindowFocus: "always",
  });
}
